import { render, staticRenderFns } from "./CreateIssue.vue?vue&type=template&id=12991e45&scoped=true&"
import script from "./CreateIssue.vue?vue&type=script&lang=js&"
export * from "./CreateIssue.vue?vue&type=script&lang=js&"
import style0 from "./CreateIssue.vue?vue&type=style&index=0&id=12991e45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12991e45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12991e45')) {
      api.createRecord('12991e45', component.options)
    } else {
      api.reload('12991e45', component.options)
    }
    module.hot.accept("./CreateIssue.vue?vue&type=template&id=12991e45&scoped=true&", function () {
      api.rerender('12991e45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Issues/Components/CreateIssue.vue"
export default component.exports